import { render } from "./TechnopawsHeader.vue?vue&type=template&id=89f659f0&scoped=true"
import script from "./TechnopawsHeader.vue?vue&type=script&lang=js"
export * from "./TechnopawsHeader.vue?vue&type=script&lang=js"

import "./TechnopawsHeader.vue?vue&type=style&index=0&id=89f659f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f659f0"],['__file',"TechnopawsHeader.vue"]])

export default __exports__